import "./update.scss";
import Sidebar from "../sidebar/Sidebar";
import Navbar from "../navbar/Navbar";
import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { resultInputs } from "../../formSource";
import { serverUrl } from "../../temp";

const ResultUpdate = ({ title }) => {
  // Extracting resultId using regular expressions
  const location = useLocation();
  const resultId = location.pathname.match(/\/upd_result\/(\d+)/)?.[1];

  // Initializing state
  // const [file, setFile] = useState(null);
  const [inputValues, setInputValues] = useState("");
  let [token] = useState(localStorage.getItem("token"));

  const redirectToLogin = () => {
    alert("Plaese Login first then you can access this page...");
    window.location.href = "/"; // Replace "/login" with the actual login page path
  };

  const navigate = useNavigate();

  useEffect(() => {
    const fetchResult = async () => {
      try {
        const response = await fetch(`${serverUrl}/result/${resultId}`, {
          method: "GET",
        });
        if (!response.ok) {
          throw new Error("Failed to fetch quiz");
        }
        const data = await response.json();
        console.log("abbas", data);
        setInputValues(data.data);
        // setFile(data.data.logo);
        localStorage.setItem("quizData", JSON.stringify(data));
      } catch (error) {
        console.error(error);
      }
    };

    if (resultId) {
      fetchResult();
    }
  }, [resultId]);
  // console.log("quiz in a state:", data);

  const handleInputChange = (e) => {
    setInputValues({
      ...inputValues,
      [e.target.name]: e.target.value,
    });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    const formData = {
      id: resultId,
      center_id: inputValues.center_id,
      exam_id: inputValues.exam_id,
      student_id: inputValues.student_id,
      mark: inputValues.mark,
      status: parseInt(inputValues.status),
    };
    console.log("Abbas", formData);

    // Send formData to the server using an HTTP request to update
    fetch("${serverUrl}/upd_result/", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData), // Pass the object as the body
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("Response from API", data);
        // Navigate to the desired page after API response
        navigate(`/result/${resultId}`);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      {!token && redirectToLogin()}
      {token && (
        <div className="update">
          <Sidebar />
          <div className="updateContainer">
            <Navbar />
            <div className="top">
              <h1>{title}</h1>
            </div>
            <div className="bottom">
              {/* <div className="left">
                                <img
                                    src={
                                        // file
                                    }
                                    alt=""
                                    className="itemImg"
                                />
                            </div> */}
              <div className="right">
                <form onSubmit={handleUpdate}>
                  {resultInputs.map((input) => (
                    <div className="formInput" key={input.id}>
                      <label>{input.label}</label>
                      <input
                        type={input.type}
                        placeholder={input.placeholder}
                        name={input.fieldName}
                        value={inputValues[input.fieldName] || ""}
                        onChange={handleInputChange}
                        required
                        // inputMode={input.fieldName === 'no_of_quiz' ? 'numeric' : undefined}
                      />
                    </div>
                  ))}
                  <div style={{ clear: "both" }} className="formUpdate">
                    <button
                      style={{ float: "right" }}
                      // onClick={() => navigate(`/categories/${resultId}`)}
                    >
                      Update
                    </button>
                  </div>
                  <div>
                    <button
                      type="button"
                      style={{ float: "right" }}
                      onClick={() => navigate(`/result/${resultId}`)}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ResultUpdate;
